import { Search as SearchIcon } from "@mui/icons-material";
import { Box, InputAdornment, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

interface PracticeUserSearchProps {
  value: string;
  onChange: (search: string) => void;
}

const PracticeUserSearch: React.FC<PracticeUserSearchProps> = ({
  value,
  onChange,
}) => {
  const [searchValue, setSearchValue] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      onChange(searchValue);
    }, 300);

    return () => window.clearTimeout(timer);
  }, [onChange, searchValue]);

  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  return (
    <Box sx={{ flex: 1, maxWidth: 460 }}>
      <TextField
        fullWidth
        placeholder="Search by ID, Email, Name, Phone, NPI..."
        value={searchValue}
        onChange={handleSearchChange}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#9CA3AF" }} />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            "& fieldset": {
              borderColor: "#E5E7EB",
            },
            "&:hover fieldset": {
              borderColor: "#D1D5DB",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#3B82F6",
            },
          },
        }}
      />
    </Box>
  );
};

export default PracticeUserSearch;
